import { useEffect } from 'react';
import { fallbackLocale } from 'shared/assets/localization';
import { useToday } from 'shared/contexts/today';
import { useCreatePushNotificationMutation } from 'shared/hooks/queries/use-create-push-notification-mutation';
import { usePushNotificationMessageQuery } from 'shared/hooks/queries/use-push-notification-message-query';
import { useNotificationPermission } from 'shared/hooks/use-notification-permission';
import { useUser } from 'shared/hooks/use-user';
import { getPushNotificationTokenDate } from 'shared/services/local-storage';
import { PushNotificationMessageRequestState } from 'shared/services/local-storage/push-notification-message';

export const useDailyPushNotificationCheck = () => {
  const today = useToday();
  const { mutate: requestPermission } = useCreatePushNotificationMutation();
  const user = useUser();
  const { data: messageState } = usePushNotificationMessageQuery(user?.uid);
  const [permission] = useNotificationPermission();

  useEffect(() => {
    if (
      !user?.uid ||
      messageState !== PushNotificationMessageRequestState.Asked ||
      permission !== 'granted'
    ) {
      return;
    }

    const lastTokenDate = getPushNotificationTokenDate(user.uid);
    const daysSinceLastToken = lastTokenDate
      ? Math.floor(
          (today.getTime() - lastTokenDate.getTime()) / (1000 * 60 * 60 * 24),
        )
      : // no date means no token, so we assume it's been a long time (token expires after 270 days)
        270;

    if (daysSinceLastToken > 200) {
      requestPermission({
        userId: user.uid,
        locale: user.settings?.language ?? fallbackLocale,
      });
    }
  }, [
    user?.uid,
    user?.settings?.language,
    requestPermission,
    today,
    messageState,
    permission,
  ]);
};
